import Route from '@ember/routing/route';

export default class AuthenticatedTeamsShowStorageIndexRoute extends Route {}
